import React from 'react';

export type LockConfigType = {
  code: number;
  description: string;
  solution: string;
  solutionIsNumeric: boolean;
  solvedMessage: React.ReactNode[];
  wrongSolutions?: WrongSolutionType[];
}

export type WrongSolutionType = {
  solution: string;
  message: string;
}

export const locksConfig = [{
  code: 11,
  description: 'A lock with strange symbols. It takes 4 numbers to open',
  solution: '5927',
  solutionIsNumeric: true,
  solvedMessage: [
    'Congratulations! You\'ve opened the chest. Take card ',
    <span className="cardNumber">3</span>
  ]
}, {
  code: 20,
  description: 'A lock with that takes 6 letters to open',
  solution: 'eleven',
  solutionIsNumeric: false,
  solvedMessage: [
    'Congratulations! You\'ve opened the box. Take card ',
    <span className="cardNumber">4</span>
  ]
}, {
  code: 12,
  description: 'This ridicolous envelope has a lock that takes 3 digits to open',
  solution: '263',
  solutionIsNumeric: true,
  solvedMessage: [
    'Congratulations! You\'ve opened the envelope. Take card ',
    <span className="cardNumber">14</span>
  ],
  wrongSolutions: [{
    solution: '231',
    message: 'You\'re going in a right direction, but try harder!'
  }, {
    solution: '326',
    message: 'Are you sure it\'s the right order?'
  }, {
    solution: '923',
    message: 'It\'s upside down!'
  }, {
    solution: '632',
    message: 'There is another way of thinking about the order'
  }]
}, {
  code: 22,
  description: 'This absurd envelope has a lock that takes 3 digits to open',
  solution: '710',
  solutionIsNumeric: true,
  solvedMessage: [
    'Congratulations! You\'ve opened the absurd envelope. Take card ',
    <span className="cardNumber">25</span>
  ]
}, {
  code: 8,
  description: 'A box with grandpa treasure. It takes 4 digits to open',
  solution: '2437',
  solutionIsNumeric: true,
  solvedMessage: [
    'Congratulations! You\'ve opened the absurd envelope. Take card ',
    <span className="cardNumber">32</span>
  ],
  wrongSolutions: [{
    solution: '3724',
    message: 'Close, but not it. Is there something that can change the solution?'
  }]
}
];

export class Lock {
  config: LockConfigType;

  constructor(config: LockConfigType) {
    this.config = config;
  }

  sanitizeAnswer(answer: string): string {
    return `${answer}`.trim().toLowerCase();
  }

  // check if you predicted wrong solution
  getWrongSolution(answer: string): WrongSolutionType | undefined {
    if (!this.config.wrongSolutions) {
      return;
    }
    return this.config.wrongSolutions.find(s => s.solution === this.sanitizeAnswer(answer));
  }

  isSolutionCorrect(answer: string) {
    return this.sanitizeAnswer(answer) === this.config.solution;
  }

  getDescription(): string {
    return this.config.description;
  }

  getSolvedMessage() {
    return this.config.solvedMessage;
  }
}

export function getLock(code: number): Lock | undefined {
  const config = locksConfig.find(l => l.code === code);
  if (config) {
    return new Lock(config);
  }
}
